/**
*
* VideoLinkControl
*
*/

import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import useAlert from 'containers/Alerts/useAlert.js';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import IconButton from 'components/interaction/IconButton/index.jsx';
import messages from 'components/VideoConf/messages.js';
import VideoConfContext from 'components/VideoConf/VideoConfContext.js';
import Spinner from 'components/Spinner/index.jsx';
import cx from 'utils/cx.js';

const SmallSpinner = styled(Spinner)`
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
`;

const LinkDiv = styled.div`
  width: 15em;
  max-width: 15em;
`;

function VideoLinkControl(props) {
  const { meeting, onChange, className } = props;
  const { videoMeeting } = meeting;
  const { isSignedIn, addVideo, removeVideo, lockedVideo } = useContext(VideoConfContext);
  const [waiting, setWaiting] = useState(false);
  const { addError } = useAlert();
  if (!videoMeeting) {
    return isSignedIn ? (
      <IconButton icon="ss-plus" variant="link" onClick={handleAdd} disabled={waiting} className="p-0 position-relative">
        <FormattedMessage {...messages.addVideo} />
        {waiting && <SmallSpinner size="24px" />}
      </IconButton>
    ) : null;
  }

  const { info, link } = videoMeeting;

  async function handleAdd() {
    try {
      setWaiting(true);
      const data = await addVideo(meeting);
      setWaiting(false);
      onChange(data);
    } catch (error) {
      addError(error);
      setWaiting(false);
    }
  }

  async function handleRemove() {
    setWaiting(true);
    try {
      await removeVideo(meeting);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error.message);
    }
    setWaiting(false);
    onChange(null);
  }

  const title = lockedVideo(info);
  return (
    <div className={cx('d-flex', className)}>
      <LinkDiv className="d-flex flex-column">
        <a href={link} target="_blank" className="text-truncate">{link.slice(8)}</a>
        <span className="small text-muted text-truncate" title={info.owner}>{info.owner}</span>
      </LinkDiv>
      <DeleteButton
        icon="ss-trash fs-3"
        className="position-relative ms-1 py-0"
        confirmText={{ ...messages.confirmRemove, values: info }}
        onClick={handleRemove}
        disabled={waiting || Boolean(title)}
        title={title}
      >
        {waiting && <SmallSpinner size="24px" />}
      </DeleteButton>
    </div>
  );
}

VideoLinkControl.propTypes = {
  meeting: PropTypes.object,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default VideoLinkControl;
